import { useHandleBack } from "helpers/functions/useHandleBack";
import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

const CategoryView = () => {
  const [data, setData] = useState<any>({});
  const navigate = useNavigate();
  const { state } = useLocation();
  // console.log(state, "state----1");

  const handleBack = useHandleBack("/category");

  useEffect(() => {
    setData(state);
  }, [state]);

  // console.log(data, "data----1");

  // const displayValue = (val: any) => val || "-";

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Card>
              {/* Header */}
              <Card.Header>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
                  {/* Left side: Back arrow + Title */}
                  <div className="d-flex align-items-center gap-3">
                    <span
                      onClick={handleBack}
                      style={{ color: "#6c757d", textDecoration: "none" }}
                    >
                      <i
                        className="bi bi-arrow-left"
                        style={{ fontSize: "1.2rem", cursor: "pointer" }}
                        aria-label="Back"
                      />
                    </span>
                    <h5 className="card-title mb-0">View Category</h5>
                  </div>

                  {/* Right side: Breadcrumb */}
                  <div
                    className="text-muted"
                    style={{ fontSize: "0.9rem", cursor: "pointer" }}
                  >
                    <span
                      className="text-muted"
                      style={{ fontSize: "0.9rem", cursor: "pointer" }}
                      onClick={handleBack}
                    >
                      Category
                    </span>{" "}
                    &gt;{" "}
                    <span
                      className="text-muted"
                      style={{ fontSize: "0.9rem", cursor: "pointer" }}
                    >
                      View Category
                    </span>
                  </div>
                </div>
              </Card.Header>

              {/* Body */}
              <Card.Body>
                {/* Category Details */}
                <h6 className="mb-3">Category Details</h6>
                <Row className="bg-light p-3 rounded mb-4">
                  <Col md={4} xs={12}>
                    <strong>Category Name : </strong> {data?.category_name}
                  </Col>
                  <Col md={4} xs={12}>
                    <strong>%WEB : </strong> {data?.web_per || "-"}
                  </Col>
                  <Col md={4} xs={12}>
                    <strong>%System : </strong> {data?.system_per || "-"}
                  </Col>
                </Row>

                {/* Attributes */}
                <h6 className="mb-3">Attributes</h6>
                <div className="d-flex flex-wrap gap-2 mb-4">
                  {data?.attributes?.length ? (
                    data.attributes.map((attr: any, index: number) => (
                      <span
                        key={attr.id || index}
                        className="badge rounded-pill"
                        style={{
                          backgroundColor: "#f0f2f5",
                          color: "#495057",
                          fontSize: "0.9rem",
                          padding: "0.6rem 1rem",
                        }}
                      >
                        {attr.label}
                      </span>
                    ))
                  ) : (
                    <span className="text-muted">No attributes</span>
                  )}
                </div>

                {/* Back button */}
                <div className="d-flex justify-content-center">
                  <Button
                    onClick={handleBack}
                    // variant="light"
                    // style={{
                    //   border: "1px solid #ced4da",
                    //   backgroundColor: "white",
                    // }}
                    className="btn btn-secondary"
                  >
                    Back
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CategoryView;
